export default __webpack_public_path__ + "static/media/QT.7db1120f.png";